import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useListPlatformPendencies } from '../../api/generated/platform/platform';
import type { Me } from '../../api/generated/model';
import { Alert } from '../../design/primitives/Alert';
import styles from './platform.module.css';

export interface PendencyNoticeProps {
  readonly me: Me;
}

/**
 * O aviso de decisoes de negocio em aberto, exclusivo do Super Admin.
 *
 * ELE E A METADE VISIVEL DE UMA TROCA, e sem ele a troca e subtracao pura. Ate 16 de
 * agosto de 2026 o conteudo provisorio se anunciava RECUSANDO: o processo nao subia em
 * producao com preco de um centavo ou termo `0.0.0-placeholder`, e as operacoes afetadas
 * respondiam 503. O cliente trocou as duas guardas por este aviso, para poder exercitar
 * a plataforma inteira antes de existir aluno real.
 *
 * Uma recusa de boot nao depende de ninguem olhar. Este aviso depende — e e por isso que
 * ele vive na CASCA, e nao numa tela de configuracao que se visita por vontade.
 *
 * NAO HA COMO DISPENSAR PARA SEMPRE. O botao abre e fecha o detalhe, e o resumo fica.
 * Um "nao mostrar de novo" devolveria a plataforma ao estado que a troca criou — a
 * guarda removida e o aviso invisivel — com a diferenca de que a pessoa teria escolhido
 * isso uma vez, meses antes, e nao lembraria.
 */
export function PendencyNotice({ me }: PendencyNoticeProps) {
  const { t } = useTranslation();
  const [aberto, setAberto] = useState(false);

  // A leitura so acontece para Super Admin. Sem o `enabled`, todo professor e todo
  // aluno pediriam a rota a cada carga da casca para receber 403 — ruido no log de
  // acesso exatamente na resposta que interessa quando alguem tenta o que nao pode.
  const ehAdmin = me.role === 'super_admin';
  const { data } = useListPlatformPendencies({ query: { enabled: ehAdmin } });

  if (!ehAdmin) return null;

  const pendencias = data ?? [];
  if (pendencias.length === 0) return null;

  // Criticas primeiro. E a ordenacao por consequencia: dinheiro e texto juridico antes
  // do resto, porque uma lista de doze itens com o mesmo peso e uma lista que ninguem le.
  const ordenadas = [...pendencias].sort((a, b) => Number(b.critical) - Number(a.critical));
  const criticas = ordenadas.filter((p) => p.critical).length;

  return (
    <div className={styles.pendencyNotice}>
      <Alert tone="warning" title={t('pendencies.title', { count: pendencias.length })}>
        <p className={styles.pendencySummary}>
          {t('pendencies.summary', { count: criticas })}
        </p>

        <button
          type="button"
          className={styles.pendencyToggle}
          aria-expanded={aberto}
          onClick={() => setAberto((v) => !v)}
        >
          {aberto ? t('pendencies.hide') : t('pendencies.show')}
        </button>

        {aberto ? (
          <ul className={styles.pendencyList}>
            {ordenadas.map((p) => (
              <li key={p.id} className={p.critical ? styles.pendencyCritical : undefined}>
                <span className={styles.pendencySubject}>{p.subject}</span>
                {/*
                  `placeholderCount` zero NAO significa "nenhuma": significa que a
                  pendencia nao mora em tabela — o texto dos modelos de e-mail e uma
                  constante do binario. Mostrar "0 registros" ali seria dizer que nao ha
                  o que corrigir, que e o contrario do que a linha existe para dizer.
                */}
                {p.placeholderCount > 0 ? (
                  <span className={styles.pendencyCount}>
                    {t('pendencies.rows', { count: p.placeholderCount })}
                  </span>
                ) : null}
                {p.affectedOperations.length > 0 ? (
                  <span className={styles.pendencyOps}>
                    {t('pendencies.affects', {
                      operations: p.affectedOperations.join(', '),
                    })}
                  </span>
                ) : null}
              </li>
            ))}
          </ul>
        ) : null}
      </Alert>
    </div>
  );
}
